// Select all anchor links with the data-scroll attribute
const smoothScrollLinks = document.querySelectorAll('a[data-scroll]');

// Add a click event listener to each link
smoothScrollLinks.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Get the ID of the target element from the link's data-scroll attribute
    const targetId = this.dataset.scroll;
    const targetElement = document.querySelector('#' + targetId);

    if (targetElement) {
      // Smooth scroll to the target element
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Scroll to top
      targetElement.focus();
    }
  });
});

/*
How to Use:
<a data-scroll="targetElement">Scroll to Target</a>
<div id="targetElement">This is the target element!</div>
*/